// extracted by mini-css-extract-plugin
module.exports = {"root":"TextContainer_root__1vyGG","icon":"TextContainer_icon__1k3sb","text":"TextContainer_text__3NNOH"};